import { use } from 'react';
import AuthProviderContext from 'shared/features/auth/authentication/providers/contexts/auth-provider-context';
import { getCurrentEnvironment } from 'shared/utils/environment-utils';

type UseAppInformationReturn = {
  tenantName: string | undefined;
  appVersion: string;
  environment: string;
  shouldShowFeatureFlags: boolean;
  isProduction: boolean;
};

const useAppInformation = (): UseAppInformationReturn => {
  const {
    tenant: { name: tenantName },
  } = use(AuthProviderContext);

  const environment = getCurrentEnvironment();
  const appVersion = import.meta.env.PACKAGE_VERSION;
  const isProduction = environment === 'production';
  const shouldShowFeatureFlags = !isProduction || tenantName?.toLowerCase() === 'hertek';

  return {
    tenantName,
    appVersion,
    environment,
    shouldShowFeatureFlags,
    isProduction,
  };
};

export default useAppInformation;
